exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group {\n  margin-bottom: 5px;\n}\n\ninput, select {\n  padding: 0 14px !important;\n  height: 28px;\n}\n\n.input-group input {\n  padding-left: 5px !important;\n  padding-right: 5px !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /root/production/sne-pro/src/app/component/settings/settings.component.css
// module id = ../../../../../src/app/component/settings/settings.component.css
// module chunks = main